module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-532.ab3a024.woff2";